var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 p-3"},[_c('form-personal-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }